import { useQuery } from '@apollo/client';

import { GET_COMPANIES, GetCompaniesForUserQuery, GetCompaniesForUserQueryVariables } from '../graphql';
import { useCurrentUser } from './useCurrentUser';

export type GetCompaniesQueryCompany = NonNullable<GetCompaniesForUserQuery['getCompaniesForUser']>[number];

export const useCompanies = ():
  | { companies: null; loading: true }
  | { companies: GetCompaniesQueryCompany[]; loading: false } => {
  const { loading: userLoading, user } = useCurrentUser();
  const {
    data,
    error: companiesError,
    loading: companiesLoading,
  } = useQuery<GetCompaniesForUserQuery, GetCompaniesForUserQueryVariables>(
    GET_COMPANIES,
    !user?.id ? { skip: true } : { variables: { userId: user.id } },
  );

  if (companiesError) {
    throw companiesError;
  }

  if (!user || userLoading || companiesLoading) {
    return { companies: null, loading: true };
  }

  if (!data) {
    throw new Error('No data returned from useCompanies');
  }

  const companies = data.getCompaniesForUser || [];

  return { companies, loading: false };
};
